import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CALYPSO, GREAT_WHITE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_COLOR = GREAT_WHITE;
const ACTIVE_COLOR = CALYPSO;
const SolidLine = styled.div.withConfig({
  displayName: "SolidColumnGridLine__SolidLine",
  componentId: "sc-1s5k1z6-0"
})([".hs-private.hs-private.hs-private &{z-index:2;position:absolute;height:", "px;width:10px;box-sizing:border-box;border-left:", ";opacity:", ";}"], props => props.height, props => props.isActive ? `2px solid ${ACTIVE_COLOR}` : `1px solid ${DEFAULT_COLOR}`, props => props.isActive ? '0.5' : '1');
const SolidColumnGridLine = ({
  height,
  isActive = true,
  left,
  top
}) => {
  return /*#__PURE__*/_jsx(SolidLine, {
    height: height,
    isActive: isActive,
    style: {
      left: isActive ? left - 1 : left,
      top
    }
  });
};
SolidColumnGridLine.propTypes = {
  height: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired
};
export default SolidColumnGridLine;